import { requestKarangoApi } from "../../core/api/karangoTransport";

// Discussion de groupe d'un evenement — routes dediees, jamais les routes
// generiques de messagerie directe (refusees cote serveur pour un thread
// d'evenement). Cf. docs/event-discussion-messaging-spec.md, section 3.3.

export async function listEventDiscussionMessages(
  eventId,
  { limit = 50, before, beforeId, feed, signal } = {}
) {
  if (!eventId) {
    throw new Error("eventId requis.");
  }

  const params = new URLSearchParams();
  params.set("limit", String(limit));
  if (feed) params.set("feed", feed);
  if (before) {
    params.set("before", String(before));
  }
  if (beforeId) {
    params.set("beforeId", String(beforeId));
  }

  const payload = await requestKarangoApi(
    `/v1/events/${encodeURIComponent(String(eventId))}/discussion?${params.toString()}`,
    { requiresAuth: true, signal }
  );

  return {
    threadId: payload?.threadId || null,
    messages: Array.isArray(payload?.messages) ? payload.messages : [],
    nextCursor: payload?.nextCursor || null,
    totalCount: Math.max(0, Number(payload?.totalCount) || 0),
  };
}

export async function postEventDiscussionMessage(eventId, content, { signal, clientMessageId } = {}) {
  if (!eventId) {
    throw new Error("eventId requis.");
  }

  return requestKarangoApi(
    `/v1/events/${encodeURIComponent(String(eventId))}/discussion/messages`,
    { method: "POST", requiresAuth: true, body: { content, ...(clientMessageId ? { clientMessageId } : {}) }, signal }
  );
}

export async function deleteEventDiscussionMessage(eventId, messageId, { signal } = {}) {
  if (!eventId || !messageId) {
    throw new Error("eventId et messageId requis.");
  }

  const payload = await requestKarangoApi(
    `/v1/events/${encodeURIComponent(String(eventId))}/discussion/messages/${encodeURIComponent(String(messageId))}`,
    { method: "DELETE", requiresAuth: true, signal }
  );

  return payload?.message || null;
}

// Masquage organisateur/admin : invisible pour les participants, sans trace.
export async function hideEventDiscussionMessage(eventId, messageId, hidden, { signal } = {}) {
  if (!eventId || !messageId) {
    throw new Error("eventId et messageId requis.");
  }

  const payload = await requestKarangoApi(
    `/v1/events/${encodeURIComponent(String(eventId))}/discussion/messages/${encodeURIComponent(String(messageId))}/hide`,
    { method: "POST", requiresAuth: true, body: { hidden: Boolean(hidden) }, signal }
  );

  return payload?.message || null;
}

// Reutilise l'endpoint de signalement generique (targetType MESSAGE, deja
// generique a tout Message/MessageThread) — aucune route dediee necessaire,
// cf. docs/event-discussion-messaging-spec.md, section 3.7.
export async function reportEventDiscussionMessage(
  messageId,
  { reason = "other", details = "Signalement depuis la discussion d'evenement.", signal } = {}
) {
  if (!messageId) {
    return null;
  }

  return requestKarangoApi("/v1/reports", {
    method: "POST",
    requiresAuth: true,
    signal,
    body: {
      targetType: "MESSAGE",
      targetId: String(messageId),
      reason,
      details,
    },
  });
}

export async function markEventDiscussionRead(eventId, { signal } = {}) {
  if (!eventId) {
    throw new Error("eventId requis.");
  }

  return requestKarangoApi(
    `/v1/events/${encodeURIComponent(String(eventId))}/discussion/read`,
    { method: "POST", requiresAuth: true, signal }
  );
}

export async function getLatestEventAnnouncement(eventId, { signal } = {}) {
  const payload = await requestKarangoApi(
    `/v1/events/${encodeURIComponent(String(eventId))}/announcements/latest`,
    { requiresAuth: true, signal }
  );
  return payload?.announcement || null;
}

export async function createEventAnnouncement(eventId, { content, channels, includeInterested = false }, { signal } = {}) {
  return requestKarangoApi(
    `/v1/events/${encodeURIComponent(String(eventId))}/announcements`,
    { method: "POST", requiresAuth: true, body: { content, channels, ...(includeInterested ? { includeInterested: true } : {}) }, signal }
  );
}

export async function getEventAnnouncementAudience(eventId, { signal } = {}) {
  const payload = await requestKarangoApi(
    `/v1/events/${encodeURIComponent(String(eventId))}/announcements/audience`,
    { requiresAuth: true, signal }
  );
  return payload?.audience || null;
}
